import { Carousel } from '@/components/shared/carousel';
import { LearningTypeCard } from '@/components/shared/learning-type-card';
import { PathType } from '@/data/learning-path/interfaces';
import { usePathsByScope } from '@/data/learning-path/path';
import { CardsSkeleton } from '@/packages/home/components/skeleton';

interface LearningPathsCarouselProps {
  global?: boolean;
  limit?: number;
}

export const LearningPathCarousel = ({
  global = false,
  limit = 50,
}: LearningPathsCarouselProps) => {
  const { paths, isFetching, error } = usePathsByScope({
    scope: global ? PathType.Global : PathType.Company,
  });

  const slidesComponents = paths?.slice(0, limit)?.map((path) => {
    const resourcesCount =
      path.resources_count && path.resources_count > 0
        ? `${path.resources_count} ${path.resources_count === 1 ? 'recurso' : 'recursos'}`
        : '';

    return (
      <LearningTypeCard
        key={path.id}
        description={path.description || ''}
        label={path.title}
        image={path.header_image_url}
        link={`/trilhas/${path.id}`}
        info={resourcesCount}
      />
    );
  });

  if (isFetching) return <CardsSkeleton withTextSkeleton={false} />;

  if ((!isFetching && !paths?.length) || error) return null;

  return <Carousel slidesComponents={slidesComponents || []} />;
};
